import AddDealToCartButton from './AddDealToCartButton';

export default AddDealToCartButton;
